import type { Feature } from '@luna/gatekeeper';

export const pinDeliveryFromCardDelivery: Feature = {
    enabled: true,
    _description: 'Displays pin delivery from card delivery card in the delivery settings section',
};
